import { AppBar, Grid, Typography } from '@mui/material'
import { SvgIconProps } from '@mui/material/SvgIcon'
import Moment from 'moment'
import * as React from 'react'
import { IPatient } from '../../Definitions'

export interface IActionBarItem {
  icon: React.ReactElement<SvgIconProps>
  label: string
  onClick: () => void
  disabled?: boolean
}

interface IActionBarProps {
  items: IActionBarItem[]
  patient?: IPatient
}

const ActionBar: React.FC<IActionBarProps> = ({ items, patient }) => {
  const appBarSx = {
    boxShadow: 'none',
    width: '100%',
    backgroundColor: (theme: any) =>
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200],
    color: (theme: any) => theme.palette.text.primary,
    paddingBottom: '10px',
    paddingLeft: '12px',
    paddingTop: '10px',
  }

  const phoneNumber = () => {
    return patient ? (
      patient.cellPhone ? (
        `CELL PHONE: ${patient.cellPhone}`
      ) : patient.homePhone ? (
        `HOME PHONE: ${patient.homePhone}`
      ) : patient.workPhone ? (
        `WORK PHONE: ${patient.workPhone}`
      ) : (
        <em>No phone number available</em>
      )
    ) : (
      ''
    )
  }

  return (
    <AppBar sx={appBarSx} position="relative">
      <Grid container direction="row">
        <Grid item>
          <Typography noWrap variant="caption">
            {patient ? `PATIENT ID: ${patient.patientIdNumber}` : ''}
            {patient && patient.preCertNumber
              ? ` [PRE-CERT#: ${patient.preCertNumber}]`
              : ''}
          </Typography>
          <Typography noWrap variant="body2">
            <strong>
              {patient
                ? `${patient.lastName}, ${patient.firstName} 
                        [DOB: ${
                          patient.dateOfBirthText
                            ? Moment(patient.dateOfBirthText).format('MM/DD/YYYY')
                            : ''
                        }]`
                : ''}
            </strong>
          </Typography>
          <Typography noWrap variant="caption">
            {patient
              ? `PATIENT ADDRESS: ${patient.address?.line1}, ${patient.address?.city}, ${patient.address?.state} ${patient.address?.zip}`
              : ''}
          </Typography>
          <Grid container spacing={2} style={{ alignItems: 'baseline' }}>
            <Grid item>
              <Typography noWrap variant="caption">
                {phoneNumber()}
              </Typography>
            </Grid>
            <Grid item>
              {patient?.allowContact == false && (
                <Typography noWrap variant="body2" color="error">
                  <strong>DO NOT CONTACT PATIENT</strong>
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item alignContent="center">
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            style={{ marginTop: '24px' }}
          >
            {items.map((child, index) => {
              return (
                <div
                  key={index}
                  style={{
                    alignItems: 'center',
                    opacity: child.disabled ? 0.38 : 1,
                    cursor: child.disabled ? 'default' : 'pointer',
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: '25px',
                  }}
                  onClick={child.onClick}
                >
                  <div>{child.icon}</div>
                  <div
                    style={{
                      fontSize: '0.8125rem',
                      marginLeft: '5px',
                    }}
                  >
                    {child.label}
                  </div>
                </div>
              )
            })}
          </Grid>
        </Grid>
      </Grid>
    </AppBar>
  )
}

export default ActionBar
